/**
 * Toolbar Shared Styles, Constants & Helpers
 */

// ── Shift presets ──

export const SHIFT_PRESETS = [
  { label: '1T', days: 1 },
  { label: '2T', days: 2 },
  { label: '3T', days: 3 },
  { label: '5T', days: 5 },
  { label: '1W', days: 5 },
  { label: '2W', days: 10 },
  { label: '4W', days: 20 },
  { label: '1M', days: 22 },
] as const;

// ── localStorage helpers ──

const TOOLBAR_STORAGE_KEY = 'roadmap_2026_toolbar_position';

export function loadToolbarPosition(): { x: number; y: number } | null {
  try {
    const raw = localStorage.getItem(TOOLBAR_STORAGE_KEY);
    if (!raw) return null;
    const pos = JSON.parse(raw);
    if (typeof pos.x === 'number' && typeof pos.y === 'number') return pos;
  } catch { /* ignore */ }
  return null;
}

export function saveToolbarPosition(x: number, y: number) {
  localStorage.setItem(TOOLBAR_STORAGE_KEY, JSON.stringify({ x, y }));
}

export function clearToolbarPosition() {
  localStorage.removeItem(TOOLBAR_STORAGE_KEY);
}

// ── Style constants ──

export const btnBase: React.CSSProperties = {
  height: 24,
  width: 24,
  padding: 0,
  fontSize: 10,
  fontWeight: 500,
  border: '1px solid #e5e7eb',
  borderRadius: 5,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f9fafb',
  color: '#374151',
  flexShrink: 0,
};

export const dividerStyle: React.CSSProperties = {
  width: 1,
  height: 18,
  backgroundColor: '#e5e7eb',
  margin: '0 2px',
  flexShrink: 0,
};

export const popoverStyle: React.CSSProperties = {
  position: 'absolute',
  bottom: '100%',
  left: '50%',
  transform: 'translateX(-50%)',
  marginBottom: 8,
  backgroundColor: '#fff',
  borderRadius: 10,
  boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
  border: '1px solid #e5e7eb',
  padding: 10,
  zIndex: 10000,
  minWidth: 240,
};

export const presetBtnStyle: React.CSSProperties = {
  height: 28,
  padding: '0 6px',
  fontSize: 11,
  fontWeight: 600,
  border: '1px solid #d1d5db',
  borderRadius: 5,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2,
  backgroundColor: '#f3f4f6',
  color: '#1f2937',
  flex: 1,
  minWidth: 0,
};

export const sectionLabelStyle: React.CSSProperties = {
  fontSize: 10,
  color: '#9ca3af',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  marginBottom: 4,
};

export const sectionDividerStyle: React.CSSProperties = {
  borderTop: '1px solid #e5e7eb',
  marginTop: 8,
  paddingTop: 8,
};
